<div class="users-input">
  <mat-label class="users-label">{{ 'billing.numberOfUsers' | translate }}</mat-label>

  <mat-form-field class="users-field" floatLabel="never">
    <input
      matInput
      type="text"
      inputmode="numeric"
      [attr.maxlength]="maxUsersDigits"
      [attr.placeholder]="showPh ? basePlaceholder : null"
      [(ngModel)]="users"
      (keydown)="preventInvalidKeys($event)"
      (input)="onUsersInput($event)"
      (paste)="onUsersPaste($event)"
      (focus)="showPh = false"
      (blur)="showPh = shouldShowPlaceholder()"
    />

    <div class="spin-controls" aria-hidden="true">
      <span (click)="step(+1)" [trackClick]="{ page: 'Changed Users Selection On Plan Page', control: 'Arrow Up', usercount: users ?? 1 }">
        <mat-icon class="icon-btn up">arrow_drop_up</mat-icon>
      </span>
      <span (click)="step(-1)" [trackClick]="{ page: 'Changed Users Selection On Plan Page', control: 'Arrow Down', usercount: users ?? 1 }">
        <mat-icon class="icon-btn down">arrow_drop_down</mat-icon>
      </span>
    </div>
  </mat-form-field>
</div>
